import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NbComponentStatus,
  NbDialogRef,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbTagComponent,
  NbTagInputAddEvent,
  NbToastrService,
} from "@nebular/theme";
import * as _ from "lodash";
import { remove } from "lodash";
import { environment } from "../../../environments/environment";
import { EMAIL_PATTERN } from "../../@auth/components/constants";
import { User } from "../../@core/data/users";
import { Customer, DiscountPolicy } from "../../models/customer.model";
import { Person } from "../../models/person.model";
import { Catalog } from "../../models/product.model";
import Shop from "../../models/shop.model";

import { CustomerService } from "../../services/customer.service";
import { DialogImagesUploadComponent } from "../dialog-images-upload/dialog-images-upload.component";
import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";

@Component({
  selector: "ngx-dialog-customer",
  templateUrl: "dialog-customer.component.html",
  styleUrls: ["dialog-customer.component.scss"],
})
export class DialogCustomerComponent implements OnInit {
  @Input() header: string;
  @Input() mode: string;
  @Input() shopId: string;
  @Input() user?: User;
  @Input() customer: Customer = new Customer();
  @Input() users?: Person[];
  @Input() productCategories?: Catalog[] = [];

  status: string = "0";
  trees: Set<string> = new Set([]);
  diaForm: FormGroup;
  submitted = false;
  loading = false;
  edited = false;
  imageURL = "";
  imagesUrl = [];
  menu = "info";
  categorySelected: Catalog = new Catalog();
  discountPercent: number = 0;
  formatCurrency: string = environment.formatCurrency
    ? environment.formatCurrency
    : "#,###,###,###";
  initAmount: string = "";

  constructor(
    protected ref: NbDialogRef<DialogCustomerComponent>,
    private fb: FormBuilder,
    private customerService: CustomerService,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit() {
    const fullNameValidators = [
      Validators.minLength(1),
      Validators.maxLength(250),
      Validators.required,
    ];
    const mobileValidators = [Validators.required];
    const stringValidators = [
      Validators.minLength(1),
      Validators.maxLength(500),
    ];
    const emailValidators = [Validators.pattern(EMAIL_PATTERN)];

    this.diaForm = this.fb.group({
      fullName: ["", fullNameValidators],
      description: ["", stringValidators],
      dob: [],
      gender: [],
      mobile: ["", mobileValidators],
      cardId: [],
      cardIdPlace: [],
      cardIdDate: [],
      email: ["", emailValidators],
      address: ["", stringValidators],
      tax: [],
      initAmount: [],
    });

    if (!this.customer.dob) {
      this.customer.dob = new Date();
    }

    if (!this.customer.cardIdDate) {
      this.customer.cardIdDate = new Date();
    }

    if (this.customer.tags && this.customer.tags.length > 0) {
      var trees = new Set([]);
      this.customer.tags.forEach(function (value) {
        trees.add(value);
      });
      this.trees = trees;
    } else {
      this.trees.add("KH");
    }
    if (!this.customer.sourceType || this.customer.sourceType == "") {
      this.customer.sourceType = "document";
    }
    if (!this.customer.gender) {
      this.customer.gender = "Khác";
    }
    if (this.customer.coverUrl && this.customer.coverUrl != "") {
      this.imageURL = this.customer.coverUrl;
    }
    if (this.customer.imagesUrl && this.customer.imagesUrl.length > 0) {
      this.imagesUrl = _.clone(this.customer.imagesUrl);
    }
    if (!this.customer.content) {
      this.customer.content = "";
    }
    if (this.customer.initAmount) {
      this.initAmount = this.customer.initAmount.toString();
    }
  }

  cancel() {
    if (this.edited) {
      this.ref.close(this.customer);
    } else {
      this.ref.close();
    }
  }

  selectMenu(value) {
    this.menu = value;
  }

  selectAssign(value) {
    if (value) {
      this.customer.assignBy = value.objectId;
      this.customer.assignName = value.objectName;
    }
  }

  //DiscountPolicy
  addDiscountPolicy() {
    if (this.categorySelected) {
      const discountPolicy = new DiscountPolicy();
      discountPolicy.categoryId = this.categorySelected.id;
      discountPolicy.categoryName = this.categorySelected.title;
      discountPolicy.discountPercent = parseFloat(
        this.discountPercent.toString()
      );
      discountPolicy.createdOn = new Date();

      if (
        this.customer.discountPolicies &&
        this.customer.discountPolicies.length >= 0
      ) {
        const index = _.findIndex(this.customer.discountPolicies, {
          categoryId: this.categorySelected.id,
        });
        if (index >= 0) {
          this.customer.discountPolicies[index].discountPercent =
            discountPolicy.discountPercent;
          this.customer.discountPolicies[index].createdOn =
            discountPolicy.createdOn;
        } else {
          this.customer.discountPolicies.push(discountPolicy);
        }
      } else {
        this.customer.discountPolicies = [discountPolicy];
      }

      this.discountPercent = 0;
    }
  }

  removeDiscountPolicy(item) {
    const index = this.customer.discountPolicies.indexOf(item);
    if (index > -1) {
      this.customer.discountPolicies.splice(index, 1);
    }
  }

  submit() {
    this.submitted = true;

    var tags: string[] = [];
    this.trees.forEach(function (item) {
      tags.push(item);
    });
    this.customer.tags = tags;
    this.customer.email = this.customer.email ? this.customer.email : "";
    this.customer.mobile = this.customer.mobile
      ? this.customer.mobile.replace(" ", "").trim()
      : "";

    this.customer.cardId = this.customer.cardId ? this.customer.cardId : "";
    this.customer.cardIdPlace = this.customer.cardIdPlace
      ? this.customer.cardIdPlace
      : "";
    this.customer.cardIdDate = this.customer.cardIdDate
      ? this.customer.cardIdDate
      : new Date();
    this.customer.coverUrl = this.customer.coverUrl
      ? this.customer.coverUrl
      : "";
    this.customer.fullName = this.customer.fullName
      ? this.customer.fullName
      : "";
    if (this.customer.fullName != "") {
      this.customer.lastName = this.customer.fullName.split(" ")[0].trim();
      this.customer.firstName = this.customer.fullName
        .replace(this.customer.lastName, "")
        .trim();
    }
    if (this.customer.dob) {
      this.customer.dobYear = new Date(this.customer.dob).getFullYear();
      this.customer.dobMonth = new Date(this.customer.dob).getMonth() + 1;
      this.customer.dobDay = new Date(this.customer.dob).getDate();
    }

    this.customer.gender = this.customer.gender ? this.customer.gender : "Khác";
    this.customer.address = this.customer.address ? this.customer.address : "";
    this.customer.tax = this.customer.tax ? this.customer.tax : "";
    this.customer.description = this.customer.description
      ? this.customer.description
      : "";
    this.customer.tags = this.customer.tags ? this.customer.tags : [];
    this.customer.imagesUrl = this.customer.imagesUrl
      ? this.customer.imagesUrl
      : [];

    if (!this.customer.assignBy) {
      this.customer.assignBy = this.user.uid;
      this.customer.assignName = this.user.displayName;
      this.customer.assignee = {
        uid: this.user.uid,
        displayName: this.user.displayName,
        email: this.user.email,
      };
    } else {
      const assign = _.find(this.users, { id: this.customer.assignBy });
      if (assign) {
        this.customer.assignName = assign.fullName;
        const assignee: User = {
          uid: assign.id,
          displayName: assign.fullName,
          email: assign.email,
        };
        this.customer.assignee = assignee;
      }
    }

    if (this.mode == "edit") {
      this.edit();
    } else {
      this.create();
    }
  }

  create() {
    this.loading = true;
    this.submitted = true;

    console.log("create:", this.customer);

    this.customerService
      .create(this.customer)
      .then((data) => {
        this.customer = data;

        this.loading = false;
        this.submitted = false;

        this.ref.close(this.customer);
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
      });
  }

  edit() {
    this.loading = true;
    this.submitted = true;

    this.customerService
      .update(this.customer)
      .then((data) => {
        this.loading = false;
        this.submitted = false;

        this.edited = true;
        this.ref.close(this.customer);
        this.showToast("success", "Cập nhật khách hàng", "thành công");
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
        this.showToast("warning", "Cập nhật khách hàng", "thất bại");
      });
  }

  delete(item: Customer) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa khách hàng?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.customerService
            .delete(item.shopId, item.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              this.customer.isDeleted = true;
              this.ref.close(this.customer);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  //Images
  openGallery() {
    this.dialogService
      .open(DialogImagesUploadComponent, {
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.addImage(value);
        }
      });
  }

  updateImage(imageUrl) {
    if (imageUrl && imageUrl != "") {
      this.customer.coverUrl = imageUrl;
      this.imageURL = imageUrl.replace("_400x400", "");
    }
  }
  removeCoverUrl() {
    this.customer.coverUrl = "";
    this.imageURL = "/assets/images/image-upload-bg.jpg";
  }

  addImage(obj) {
    let imageURL = obj.value;

    if (!this.customer.imagesUrl) {
      this.customer.imagesUrl = [];
    }
    this.customer.imagesUrl.push(imageURL);

    if (obj.isNew) {
      imageURL = imageURL.replace("_400x400", "");
    }
    this.imagesUrl.push(imageURL);
  }

  deleteImage(item) {
    remove(this.customer.imagesUrl, (el) => {
      return el == item;
    });
    remove(this.imagesUrl, (el) => {
      return el == item;
    });
  }

  //Tags
  onTagRemove(tagToRemove: NbTagComponent): void {
    this.trees.delete(tagToRemove.text);
  }

  onTagAdd({ value, input }: NbTagInputAddEvent): void {
    if (value) {
      this.trees.add(value);
    }
    input.nativeElement.value = "";
  }

  // control event
  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
